import { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import {
	Page
	, Content
	, Nav
} from '@beisen/chaos-ui';
import DataTable from '../DataTable/DataTable';
import FormList from '../FormList/FormList';
import { ExtensionWrap } from '../util/extension';
import {
	ifHidePopupNav,
	generateHeaderConfig,
	clearHeaderConfig
} from '../util/helper';
import transLoader from '@beisen/i18n-translation-loader';
import { addEnNavClassName } from '../util/ui';
require('./batchpage.scss');

const defaultTranslation = {
    cancel: '取消',
    nextStep: '下一步',
    checkAll: '全选'
};
/**
 * 批量操作页面
 */
export default class BatchPage extends Component {
	constructor(props, context) {
		super(props, context);
		this.cancelFn = this.cancelFn.bind(this);
		this.submitFn = this.submitFn.bind(this);
		this.selectAll = this.selectAll.bind(this);
		this.selectItem = this.selectItem.bind(this);
		this.state = {
			selectIds: '',
			selectData: []
        };
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            cancel: 'common.cancel',
            nextStep: 'table.nextStep',
            checkAll: 'table.checkAll'
        }), props.translation);
	}

	cancelFn() {
		this.props.actions.btnClearFn();
	}

	submitFn(e) {
		if(this.state.selectIds) {
			e && e.preventDefault && e.preventDefault();
			this.props.actions.btnNextFn({ selectData: this.state.selectData });
		}
		return false;
	}

	//设置壳子的导航对象并通知壳子更新导航
	setBoxHeader() {
		let title = this.props.title;
		let length = this.props.biz_data.length;
		const { translation } = this;
		generateHeaderConfig(function(headerConfig, setButton) {
			let config = Object.assign({}, headerConfig);
			//设置左侧按钮
			const left_item = [
				{
					callback: 'batchPageCancel',
					control: true,
					text: '',
					type: 'back'
				}
			];
			config = setButton('left', left_item, config);
			if(length != 0) {
				//设置右侧按钮
				const right_item = [
					{
						icon: '',
						callback: 'batchPageSubmit',
						control: true,
						text: translation.nextStep,
						type: 'text'
					}
				];
				config = setButton('right', right_item, config);
			}
			//设置中间数据
			if (title) {
				config.titleItem = {
					text: title,
					icon: '',
					callback: '',
					control: false
				};
			}
			return config;
		});
	}

	//组件销毁后获取前一个壳子的配置对象并通知壳子进行更新
	getPreHeaderConfig() {
		clearHeaderConfig();
	}

	//注册壳子回调函数
	registCallback() {
		window.globalEventManager['batchPageCancel'] = this.cancelFn.bind(this);
		window.globalEventManager['batchPageSubmit'] = this.submitFn.bind(this);
	}

	//清除壳子回调函数
	clearCallback() {
		delete window.globalEventManager['batchPageCancel'] && delete window.globalEventManager['batchPageSubmit'];
	}


	selectAll(e) {
		e.preventDefault();
		const { biz_data } = this.props;
		let { selectData } = this.state;
		if (biz_data.length == selectData.length) {
			this.setState({
				selectIds: '',
				selectData: []
			});
		} else {
			if (biz_data && biz_data.length > 0) {
				let newSelectData = [], ids = [];
				biz_data.forEach(RowItem => {
					RowItem['_id'] && ids.push(RowItem['_id'].value);
					let Item = {};
					let key;
					for (key in RowItem) {
						Item[key] = RowItem[key];
					}
					newSelectData.push(Item);
				});
				this.setState({
					selectIds: ids.join(','),
					selectData: newSelectData
				});
			}
		}
	}
	//单选
	selectItem(e, item) {
		e.preventDefault();
		let { selectData, selectIds } = this.state;
		if (!item.checked) {
			let newItem = {};
			let key;
			for (key in item) {
				if (item[key] && item[key].name == key) {
					newItem[key] = item[key].value;
				}
			}
			selectData.push(newItem);

			if (selectIds) {
				selectIds = selectIds + ',' + item['_id'].value;
			} else {
				selectIds = item['_id'].value;
			}
		} else {
			selectIds = selectIds.replace(',' + item['_id'].value, '').replace(item['_id'].value, '');
			selectData = selectData.filter(Item => {
				return item['_id'].value != Item['_id'];
			});
		}

		this.setState({
			selectData: selectData
			, selectIds: selectIds
		});
	}

	componentDidMount() {
		let top = this.props.scrollTop;
		const scrollContainer = ReactDOM.findDOMNode(this.refs.scrollContainer);
		scrollContainer.scrollTop = top;
		if (ifHidePopupNav()) {
			this.registCallback();
			this.setBoxHeader();
		}
	}

	componentWillUnmount() {
		if (ifHidePopupNav()) {
			this.clearCallback();
			this.getPreHeaderConfig();
		}
	}

	renderList() {
		if (this.props.cmp_type == 'Form') {
			return (
				<FormList
					ref="scrollContainer"
					{...this.props}
					expandRegion={null}
					isNoShowRowButton={true}
					showChecked={this.props.dataRows === undefined ? true : (this.props.dataRows === 'none' ? false : true)}
					selectIds={this.state.selectIds}
					onTableItemClick={this.selectItem} />
			);
		}

		return (
			<DataTable
				ref="scrollContainer"
				tableType={'batchTable'}
				{...this.props}
				expandRegion={null}
				isNoShowRowButton={true}
				showChecked={this.props.dataRows === undefined ? true : (this.props.dataRows === 'none' ? false : true)}
				selectIds={this.state.selectIds}
				disableLoadMore={true}
				onTableItemClick={this.selectItem}
				disableRemberPosition={true}
				noBottomButton={true}
				isBatchPage={true}
			/>
		);
	}

	render() {
		let { selectData } = this.state;
        let { biz_data, title } = this.props;
        let { translation } = this;
        const enNavButtonClass = addEnNavClassName();
        let selectAll, next;
		if (biz_data.length != 0) {
			selectAll = (
				<div className='select-all' onTouchTap={this.selectAll}>
					<i className={classNames({
						'icon-radio': selectData.length != biz_data.length
						, 'icon-radio-active': selectData.length == biz_data.length
					})} />
					<span>{translation.checkAll}</span>
				</div>
			);
			next = (<a href='javascript:;' role='right' className={enNavButtonClass} onTouchTap={this.submitFn}>{translation.nextStep}</a>);
		}

        let hideNav = ifHidePopupNav();
		return (
			<Page cls='batch_page' ref="batchPage">
				<Nav navRef={el => this.batchNav = el} title={title} style={hideNav ? { display: 'none' } : this.props.style}>
					<span role="left" className={classNames('editform-cancle-btn', enNavButtonClass)} onTouchTap={this.cancelFn}>{translation.cancel}</span>
					{next}
				</Nav>
				<Content>
					{this.props.dataRows !== 'multi' ? null : selectAll}
					<ExtensionWrap {...this.props} showChecked={true} selectIds={this.state.selectIds} disableLoadMore={true} onTableItemClick={this.selectItem}>
						{this.renderList()}
					</ExtensionWrap>
				</Content>
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Pages/BatchPage.js